/* «Гроші» — money events (/finance/money). Kept apart from uk.ts/en.ts to keep merges small. */
export const moneyUk = {
  'nav.money': 'Гроші',
  'perm.money.read': 'Гроші: події оплат з усіма їх відображеннями (Enote, Checkbox, BAS)',
  'perm.money.manage': 'Гроші: об’єднання, розділення й рішення щодо зв’язків',
  'money.title': 'Гроші',
  'money.subtitle': 'Одна подія на кожну реальну оплату: оплата Enote, фіскальний чек (Enote або Checkbox) і документ BAS поруч, з розбіжностями.',
  'money.tab.events': 'Реєстр',
  'money.tab.queues': 'Черги',
  'money.tab.batches': 'Денні документи',
  'money.rebuild': 'Перезібрати',
  'money.rebuilt': 'Зібрано: {n} оплат, зіставлено чеків {m}',
  'money.allFops': 'Усі ФОП',
  'money.noFop': 'Без ФОП',
  'money.allMethods': 'Усі способи',
  'money.allStatuses': 'Усі статуси',
  'money.allIssues': 'Усі проблеми',
  'money.allSources': 'Усі джерела',
  'money.allKinds': 'Усі види',
  'money.search': '№ оплати, фіскальний номер, документ BAS, клієнт',
  'money.review': 'Чекають рішення',
  'money.col.time': 'Час',
  'money.col.label': 'Документ',
  'money.col.fop': 'ФОП',
  'money.col.who': 'Клієнт / контрагент',
  'money.col.method': 'Спосіб',
  'money.col.amount': 'Сума',
  'money.col.sources': 'Відображення',
  'money.col.status': 'Стан',
  'money.col.day': 'День',
  'money.col.kind': 'Вид',
  'money.col.channel': 'Канал',
  'money.col.docs': 'Документи',
  'money.col.docAmount': 'За документом',
  'money.col.events': 'Сума подій',
  'money.col.diff': 'Різниця',
  'money.totals': '{n} подій · надходження {in} · виплати {out}',
  'money.empty': 'Подій за період немає',
  'money.emptyHint': 'Змініть період чи фільтри. Нові оплати й чеки потрапляють сюди автоматично за кілька хвилин після синхронізації; кнопка «Перезібрати» зробить це одразу.',
  'money.status.complete': 'Повна',
  'money.status.partial': 'Неповна',
  'money.status.unmatched': 'Без оплати',
  'money.status.matched': 'Збігається',
  'money.status.mismatch': 'Розбіжність',
  'money.issue.no_receipt': 'Немає чека',
  'money.issue.receipt_pending': 'Чек очікується',
  'money.issue.no_accounting': 'Немає в BAS',
  'money.issue.amount_mismatch': 'Сума чека ≠ оплаті',
  'money.issue.no_payment': 'Немає оплати Enote',
  'money.issue.fop_mismatch': 'Чек на касі іншого ФОП',
  'money.source.enote_payment': 'Оплата Enote',
  'money.source.enote_fiscal_receipt': 'Чек Enote (ПРРО)',
  'money.source.checkbox_receipt': 'Чек Checkbox',
  'money.source.bas_money_doc': 'Документ BAS',
  'money.source.bank_line': 'Банківська виписка',
  'money.sourceShort.enote_payment': 'Enote',
  'money.sourceShort.enote_fiscal_receipt': 'Чек Enote',
  'money.sourceShort.checkbox_receipt': 'Checkbox',
  'money.sourceShort.bas_money_doc': 'BAS',
  'money.sourceShort.bank_line': 'Банк',
  'money.method.cash': 'Готівка',
  'money.method.card': 'Картка',
  'money.method.transfer': 'Переказ',
  'money.method.mixed': 'Змішана',
  'money.method.bonus': 'Бонуси',
  'money.method.credit': 'Кредит',
  'money.linkMethod.anchor': 'Основа події',
  'money.linkMethod.exact_key': 'За ключем (чек → оплата)',
  'money.linkMethod.checkbox_link': 'Зіставлено в Checkbox',
  'money.linkMethod.fiscal_number': 'За фіскальним номером',
  'money.linkMethod.amount_time': 'Сума + час + ФОП',
  'money.linkMethod.amount_day': 'Сума за день',
  'money.linkMethod.rejected_out': 'Відокремлено людиною',
  'money.linkMethod.manual': 'Вручну',
  'money.batchKind.bas_day': 'BAS за день',
  'money.batchKind.cash_shift': 'Касова зміна (Z)',
  'money.batchKind.checkbox_shift': 'Зміна Checkbox (Z)',
  'money.channel.cash': 'Готівка',
  'money.channel.card': 'Картка / переказ',
  'money.channel.all': 'Усе',
  'money.out': 'Виплата',
  'money.return': 'Повернення',
  'money.drawerTitle': 'Подія {label}',
  'money.reps': 'Відображення поруч',
  'money.repsHint': 'Червоним — поле, що відрізняється від події.',
  'money.row.label': 'Номер',
  'money.row.time': 'Час',
  'money.row.amount': 'Сума',
  'money.row.cash': 'Готівка',
  'money.row.card': 'Картка',
  'money.row.fop': 'ФОП',
  'money.row.kind': 'Вид',
  'money.row.link': 'Зв’язок',
  'money.proposed': 'Запропоновано',
  'money.duplicate': 'Той самий чек',
  'money.confirm': 'Підтвердити',
  'money.reject': 'Не ця оплата',
  'money.confirmed': 'Зв’язок підтверджено',
  'money.rejected': 'Відокремлено; більше не зіставлятиметься з цією подією',
  'money.rejectedList': 'Відокремлені людиною',
  'money.split': 'Виділити в окрему подію',
  'money.splitDone': 'Виділено в окрему подію',
  'money.splitTitle': 'Виділити вибрані відображення?',
  'money.splitHint': 'Вони стануть окремою подією, і автоматичне зіставлення більше не поєднає їх із рештою.',
  'money.merge': 'Об’єднати ({n})',
  'money.merged': 'Події об’єднано',
  'money.mergeTitle': 'Об’єднати {n} події в одну?',
  'money.mergeHint': 'Усі відображення перейдуть до першої вибраної події. Рішення записується в історію.',
  'money.note': 'Коментар (необов’язково)',
  'money.select': 'Вибрати',
  'money.batches': 'Денні документи й Z-звіти',
  'money.decisions': 'Історія рішень',
  'money.decision.merge': 'Об’єднано',
  'money.decision.split': 'Розділено',
  'money.decision.confirm': 'Підтверджено',
  'money.decision.reject': 'Відокремлено',
  'money.journeys': 'Шлях клієнта',
  'money.completeness': 'Повнота',
  'money.receiptTotal': 'У чеках',
  'money.fiscalExpected': 'Має бути фіскалізовано',
  'money.counterparty': 'Контрагент',
  'money.client': 'Клієнт',
  'money.queue.issues': 'Проблеми подій',
  'money.queue.unmatched': 'Без оплати Enote за джерелом',
  'money.queue.review': 'Чекають рішення людини',
  'money.queue.batches': 'Денні документи з розбіжністю',
  'money.queue.none': 'Черга порожня — усе зіставлено.',
  'money.queue.open': 'Показати',
  'money.pending': 'Днів у черзі зіставлення: {n}',
  'money.lastScan': 'Остання перевірка змін: {t}',
  'money.batchesEmpty': 'Денних документів за період немає',
  'money.batchesEmptyHint': 'Тут з’являються денні документи BAS (виручка, надходження на рахунок) і Z-звіти змін, коли вони охоплюють кілька оплат.',
  'money.batchTitle': '{kind} · {day}',
  'money.batchDocs': 'Документи',
  'money.batchEvents': 'Події дня',
  'money.part': 'Частка',
}

export const moneyEn: Record<keyof typeof moneyUk, string> = {
  'nav.money': 'Money',
  'perm.money.read': 'Money: payment events with all their representations (Enote, Checkbox, BAS)',
  'perm.money.manage': 'Money: merge, split and decide links',
  'money.title': 'Money',
  'money.subtitle': 'One event per real payment: the Enote payment, the fiscal receipt (Enote or Checkbox) and the BAS document side by side, with differences.',
  'money.tab.events': 'Register',
  'money.tab.queues': 'Queues',
  'money.tab.batches': 'Daily documents',
  'money.rebuild': 'Re-match',
  'money.rebuilt': 'Done: {n} payments, {m} receipts matched',
  'money.allFops': 'All ФОП',
  'money.noFop': 'No ФОП',
  'money.allMethods': 'All methods',
  'money.allStatuses': 'All statuses',
  'money.allIssues': 'All issues',
  'money.allSources': 'All sources',
  'money.allKinds': 'All kinds',
  'money.search': 'Payment no., fiscal number, BAS document, client',
  'money.review': 'Waiting for a decision',
  'money.col.time': 'Time',
  'money.col.label': 'Document',
  'money.col.fop': 'ФОП',
  'money.col.who': 'Client / counterparty',
  'money.col.method': 'Method',
  'money.col.amount': 'Amount',
  'money.col.sources': 'Representations',
  'money.col.status': 'State',
  'money.col.day': 'Day',
  'money.col.kind': 'Kind',
  'money.col.channel': 'Channel',
  'money.col.docs': 'Documents',
  'money.col.docAmount': 'Per document',
  'money.col.events': 'Events total',
  'money.col.diff': 'Difference',
  'money.totals': '{n} events · in {in} · out {out}',
  'money.empty': 'No events in the period',
  'money.emptyHint': 'Change the period or filters. New payments and receipts arrive here a few minutes after sync; «Re-match» does it now.',
  'money.status.complete': 'Complete',
  'money.status.partial': 'Partial',
  'money.status.unmatched': 'No payment',
  'money.status.matched': 'Matches',
  'money.status.mismatch': 'Differs',
  'money.issue.no_receipt': 'No receipt',
  'money.issue.receipt_pending': 'Receipt pending',
  'money.issue.no_accounting': 'Not in BAS',
  'money.issue.amount_mismatch': 'Receipt ≠ payment',
  'money.issue.no_payment': 'No Enote payment',
  'money.issue.fop_mismatch': 'Receipt on another ФОП’s register',
  'money.source.enote_payment': 'Enote payment',
  'money.source.enote_fiscal_receipt': 'Enote receipt (ПРРО)',
  'money.source.checkbox_receipt': 'Checkbox receipt',
  'money.source.bas_money_doc': 'BAS document',
  'money.source.bank_line': 'Bank statement',
  'money.sourceShort.enote_payment': 'Enote',
  'money.sourceShort.enote_fiscal_receipt': 'Enote receipt',
  'money.sourceShort.checkbox_receipt': 'Checkbox',
  'money.sourceShort.bas_money_doc': 'BAS',
  'money.sourceShort.bank_line': 'Bank',
  'money.method.cash': 'Cash',
  'money.method.card': 'Card',
  'money.method.transfer': 'Transfer',
  'money.method.mixed': 'Mixed',
  'money.method.bonus': 'Bonuses',
  'money.method.credit': 'Credit',
  'money.linkMethod.anchor': 'Event basis',
  'money.linkMethod.exact_key': 'By key (receipt → payment)',
  'money.linkMethod.checkbox_link': 'Matched in Checkbox',
  'money.linkMethod.fiscal_number': 'By fiscal number',
  'money.linkMethod.amount_time': 'Amount + time + ФОП',
  'money.linkMethod.amount_day': 'Day amount',
  'money.linkMethod.rejected_out': 'Separated by a person',
  'money.linkMethod.manual': 'Manual',
  'money.batchKind.bas_day': 'BAS per day',
  'money.batchKind.cash_shift': 'Cash shift (Z)',
  'money.batchKind.checkbox_shift': 'Checkbox shift (Z)',
  'money.channel.cash': 'Cash',
  'money.channel.card': 'Card / transfer',
  'money.channel.all': 'All',
  'money.out': 'Outflow',
  'money.return': 'Refund',
  'money.drawerTitle': 'Event {label}',
  'money.reps': 'Representations side by side',
  'money.repsHint': 'Red: the field differs from the event.',
  'money.row.label': 'Number',
  'money.row.time': 'Time',
  'money.row.amount': 'Amount',
  'money.row.cash': 'Cash',
  'money.row.card': 'Card',
  'money.row.fop': 'ФОП',
  'money.row.kind': 'Kind',
  'money.row.link': 'Link',
  'money.proposed': 'Proposed',
  'money.duplicate': 'Same receipt',
  'money.confirm': 'Confirm',
  'money.reject': 'Not this payment',
  'money.confirmed': 'Link confirmed',
  'money.rejected': 'Separated; it will not be matched with this event again',
  'money.rejectedList': 'Separated by a person',
  'money.split': 'Split into a new event',
  'money.splitDone': 'Split into a new event',
  'money.splitTitle': 'Split the selected representations?',
  'money.splitHint': 'They become a separate event and automatic matching will not join them with the rest again.',
  'money.merge': 'Merge ({n})',
  'money.merged': 'Events merged',
  'money.mergeTitle': 'Merge {n} events into one?',
  'money.mergeHint': 'All representations move to the first selected event. The decision is recorded in the history.',
  'money.note': 'Comment (optional)',
  'money.select': 'Select',
  'money.batches': 'Daily documents and Z-reports',
  'money.decisions': 'Decision history',
  'money.decision.merge': 'Merged',
  'money.decision.split': 'Split',
  'money.decision.confirm': 'Confirmed',
  'money.decision.reject': 'Separated',
  'money.journeys': 'Client journey',
  'money.completeness': 'Completeness',
  'money.receiptTotal': 'In receipts',
  'money.fiscalExpected': 'To be fiscalised',
  'money.counterparty': 'Counterparty',
  'money.client': 'Client',
  'money.queue.issues': 'Event issues',
  'money.queue.unmatched': 'Without an Enote payment, per source',
  'money.queue.review': 'Waiting for a person',
  'money.queue.batches': 'Daily documents that differ',
  'money.queue.none': 'Queue is empty — everything is matched.',
  'money.queue.open': 'Show',
  'money.pending': 'Days waiting for matching: {n}',
  'money.lastScan': 'Last change scan: {t}',
  'money.batchesEmpty': 'No daily documents in the period',
  'money.batchesEmptyHint': 'BAS daily documents (revenue, bank inflows) and shift Z-reports appear here when they cover several payments.',
  'money.batchTitle': '{kind} · {day}',
  'money.batchDocs': 'Documents',
  'money.batchEvents': 'Events of the day',
  'money.part': 'Part',
}
